import { _ as __assign } from './tslib.es6-ebb56484.js';
import React__default from 'react';
import { U as UltimateSpecialOffers } from './UltimateSpecialOffers-55af1dbc.js';
import './getTitle-6237901b.js';

var SpecialOffers = function (props) {
    return React__default.createElement(UltimateSpecialOffers, __assign({}, props));
};

export { SpecialOffers as S };
//# sourceMappingURL=SpecialOffers-463b5fbc.js.map
